module.exports = function() {
  return new Worker(__webpack_public_path__ + "c85dce34162a513df2a2.worker.js");
};